var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConversaGrupoB(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 20,
    viewBox: "0 0 25 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.875 4.375C16.875 6.79125 14.9162 8.75 12.5 8.75C10.0838 8.75 8.125 6.79125 8.125 4.375C8.125 1.95875 10.0838 0 12.5 0C14.9162 0 16.875 1.95875 16.875 4.375Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 15.625C20 18.0412 16.6421 20 12.5 20C8.35786 20 5 18.0412 5 15.625C5 13.2088 8.35786 11.25 12.5 11.25C16.6421 11.25 20 13.2088 20 15.625Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.40051 1.25C6.62233 1.25 6.83889 1.27176 7.04801 1.3132C6.53856 2.21808 6.24794 3.2626 6.24794 4.375C6.24794 5.46031 6.52458 6.48103 7.01118 7.37045C6.81351 7.40729 6.60934 7.42658 6.40051 7.42658C4.63248 7.42658 3.19922 6.0439 3.19922 4.33829C3.19922 2.63268 4.63248 1.25 6.40051 1.25Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.30918 18.7325C3.59927 17.8838 3.125 16.8425 3.125 15.6249C3.125 14.4447 3.57071 13.43 4.24473 12.5958C1.86388 12.7806 0 14.0827 0 15.6617C0 17.2554 1.89663 18.5672 4.30918 18.7325Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7492 4.375C18.7492 5.46031 18.4726 6.48103 17.986 7.37045C18.1837 7.40729 18.3878 7.42658 18.5967 7.42658C20.3647 7.42658 21.798 6.0439 21.798 4.33829C21.798 2.63268 20.3647 1.25 18.5967 1.25C18.3748 1.25 18.1583 1.27176 17.9492 1.3132C18.4586 2.21808 18.7492 3.2626 18.7492 4.375Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6914 18.7325C23.1039 18.5672 25.0005 17.2554 25.0005 15.6617C25.0005 14.0827 23.1367 12.7806 20.7558 12.5958C21.4298 13.43 21.8755 14.4447 21.8755 15.6249C21.8755 16.8425 21.4013 17.8838 20.6914 18.7325Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConversaGrupoB);
export default __webpack_public_path__ + "static/media/conversaGrupoB.fab7258e36363110ea9113d8181c7488.svg";
export { ForwardRef as ReactComponent };